// extracted by mini-css-extract-plugin
export default {"checkbox-label":"FormItemCheckbox_checkbox-label__7G24Y"};